import React from 'react';
import statusTypes from '../../../../support/statusTypes';
import BatchDownloadComplete from './BatchDownloadComplete';
import Spinner from './Spinner';
import Restrictions from './Restrictions';
import DownloadMessage from '../../Messages/DownloadMessage/DownloadMessage';
import ViewOnlyWarning from '../../ViewOnlyWarning/ViewOnlyWarning';
import AssetSizes from '../../AssetSizes/AssetSizes';
import ProjectCodes from '../../ProjectCodes/ProjectCodes';
import Notes from '../../Notes/Notes';
import { BatchAgreements } from '../../../../shared/logicalComponents';
import useStatus from '../../../../hooks/stateful/useStatus';

const BatchDownloadForm = () => {
  const { status } = useStatus();

  const contents = () => {
    if (status === statusTypes.IN_PROGRESS) {
      return (
        <>
          <DownloadMessage />
          <ViewOnlyWarning />
          <AssetSizes />
          <ProjectCodes />
          <Notes />
        </>
      );
    }
    if (status === statusTypes.SHOW_RESTRICTIONS) {
      return <Restrictions />;
    }
    if (status === statusTypes.DOWNLOADING) {
      return <Spinner />;
    }
    if (status === statusTypes.DOWNLOAD_COMPLETE) {
      return <BatchDownloadComplete />;
    }
    return null;
  };

  return (
    <>
      <BatchAgreements />
      {contents()}
    </>
  );
};

export default BatchDownloadForm;
